// loading-spinner.component.ts
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-load-spinner',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="loading-overlay">
      <div class="loading-content">
        <mat-progress-spinner
          diameter="50"
          strokeWidth="4"
          mode="indeterminate"
          color="primary">
        </mat-progress-spinner>
      </div>
    </div>
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      backdrop-filter: blur(3px);
    }
    
    .loading-content {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }
    
    p {
      margin: 0;
      color:rgb(255, 255, 255);
      font-weight: 500;
    }
  `]
})
export class LoadSpinnerComponent {
  constructor() { }
}